import { defineComponent as _defineComponent } from 'vue';
import { useHistoryStore } from "@/stores/historyStore";
import HistoryIndicators from "../HistoryIndicators.vue";
import TextSummary from "@/components/Common/TextSummary.vue";
import DetailsLayout from "@/components/History/Layout/DetailsLayout.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryDetails',
    props: {
        history: null,
        writeable: { type: Boolean, default: true },
        summarized: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const historyStore = useHistoryStore();
        function onSave(newDetails) {
            const id = props.history.id;
            historyStore.updateHistory({ ...newDetails, id });
        }
        return { __sfc: true, props, historyStore, onSave, HistoryIndicators, TextSummary, DetailsLayout };
    }
});
